import { useState } from 'hooks'

export const useTabs = (countTabs, initTabIndex) => {
  const [activeTabIndex, setActiveTab] = useState(initTabIndex)

  return { activeTabIndex, setActiveTab }
}
